export const TAB_LIST = [
  {
    icon: 'search',
    title: '검색',
    path: 'search',
  },
  {
    icon: 'bookmark',
    title: '즐겨찾기',
    path: 'favorite',
  },
];
